import React from 'react';
import P, { InferProps } from 'prop-types';
import Grid from '@mui/material/Grid';
import ImageField from './image-field';
import SelectField from './select-field';

function PromoFieldPoll({
  setChange,
  setValidation,
  fields,
  isReadOnly,
  path,
}: InferProps<typeof PromoFieldPoll.propTypes>) {
  const [
    contentUrlField,
    ,
    ,
    ,
    /* promoType */ /* targetUrlField */ /* promoOpenInAppField */ widthField,
    heightField,
    ,
    /* textField */ pollIdField,
  ] = fields;

  return (
    <Grid container spacing={4} alignItems="center">
      <Grid item>
        <ImageField
          field={contentUrlField}
          widthField={widthField}
          heightField={heightField}
          setChange={setChange}
          key={contentUrlField.id}
          isReadOnly={isReadOnly}
          path={path}
          compact
        />
      </Grid>
      <Grid xs item>
        <SelectField
          setChange={setChange}
          setValidation={setValidation}
          field={pollIdField}
          isReadOnly={isReadOnly}
          fullWidth
        />
      </Grid>
    </Grid>
  );
}

PromoFieldPoll.propTypes = {
  setChange: P.func.isRequired,
  setValidation: P.func.isRequired,
  isReadOnly: P.bool,
  fields: P.any.isRequired,
  key: P.string,
  path: P.string.isRequired,
};

export default PromoFieldPoll;
